class LngPreBidNoteComponentCtrl implements ng.IController {}

angular.module('app').component('pkpLngPreBidNote', {
    controller: LngPreBidNoteComponentCtrl,
    template: require('app/lng-offer-bid/lng-pre-bid-note.component.html'),
    bindings: {}
});
